import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'helpers/CSSModulesUtil'
import { compose } from 'redux'
import { Card } from 'react-toolbox/lib/card'

import styles from './styles.scss'

const StyledCard = (props) => {
  const { children } = props
  return (
    <Card theme={styles}>
      { children }
    </Card>
  )
}

StyledCard.propTypes = {
}

const withStyles = CSSModules(styles)
const enhance = compose(
  withStyles
)

export default enhance(StyledCard)
